import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {isLoggedIn} from '../../utils/isLoggedIn';
import Done from 'react-icons/lib/md/done';
import _ from 'lodash';
import EditIcon from 'react-icons/lib/md/edit';
import { trackGoogleEvent } from '../../utils/googleEvents';
import {colors} from '../../shared/styles';
import {styles} from '../../views/eventStartList/styles';

export class AddEventToCalendarComponent extends Component {
  state = {
    hover: false,
  };

  onTouchTap = () => isLoggedIn() ?
    this.props.modal.handleTouchTap() : this.props.modal.handleTouchTap();

  render() {
    const {
      t,
      isMobile
    } = this.props;

    const {
      loggedInStarter,
      buttonStyle,
      isDarkButton,
      isEdit = false
    } = this.props.modal.props;
    const {hover} = this.state;

    const styleButton = (isHover) => (styles.submitButtonStyle(isHover, buttonStyle, isDarkButton));

    const styleButtonRacing = (isHover) => (styles.submitButtonRacing(isHover, styleButton(isHover)))

    const hoverProps = {
      onMouseEnter: () => this.setState({hover:true}),
      onMouseLeave: () => this.setState({hover:false})
    };

    const labelText = this.props.modal.props.label || t('Racing?');

    return (
        <div id='add-event-to-calendar' style={styles.submitButtonContainer(isMobile)}>
        {
          isEdit &&
            <div
              onClick={this.onTouchTap}
              style={styles.editButton}>
              <EditIcon color={colors.white}/>
            </div>
        }
        { !isEdit && (
          !_.isEmpty(loggedInStarter) ?
          <button
            style={styleButtonRacing(hover)}
            onClick={this.onTouchTap}
            id={'view-goals'}
            {...hoverProps}
          >
          {
          this.props.modal.props.label ||
          <div><Done size="16" /> {t('Racing')}</div>
          }
          </button>
          :
          <button
            id='join-the-start-list'
            style={styleButton(hover)}
            onClick={() => {
              trackGoogleEvent('Social', 'Click', 'Add Yourself');
              this.onTouchTap();
            }}
            {...hoverProps}
          >
            {labelText}
          </button>
        )}
      </div>
    );
  }
}

export const AddEventToCalendar = withTranslation()(AddEventToCalendarComponent);



/** WEBPACK FOOTER **
 ** ./components/control/AddEventToCalendar.js
 **/